import { useCallback, useEffect } from "react";

import useInitCore from "../../../commons/libs/hooks/use-init-core";
import { useMobileAppDispatcher, useMobileAppSelector } from "../../store/hooks";

const useInitializeApp = () => {
  const [dispatch, actions] = useMobileAppDispatcher();

  const setError = useCallback((error: Error) => dispatch(actions.error.set(error)), [dispatch, actions.error]);

  useInitCore({ onError: setError });
  const isInitCoreDone = useMobileAppSelector(state => state.core.isInitCoreDone);

  useEffect(() => {
    if (isInitCoreDone) {
      dispatch(actions.core.initAppDone());
    }
  }, [dispatch, isInitCoreDone, actions.core]);
};

export default useInitializeApp;
